import { Button } from 'components/atoms';
import { Form } from 'components/organisms';
import { sftpConnectionInitialValue } from 'components/organisms/forms/sftp-connection/SftpConnectionForm';
import { FormikHelpers } from 'formik';
import { useMutateOptions } from 'hooks';
import { useCustomParamId } from 'hooks/useParamId';
import { useTranslation } from 'react-i18next';
import { PiX } from 'react-icons/pi';
import { useNavigate } from 'react-router-dom';
import { usePostProviderSftpConnection } from 'services/providers/sftp';
import { IProviderSftpConnectionResponse } from 'services/providers/types';
import { BUTTON_VARIANT } from 'types/components/button/button.interface';

const CreateSftpConnection = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const providerId = useCustomParamId('id', 'settings/provider');
  const salesChannelId = useCustomParamId(
    'salesChannelId',
    `settings/provider/${providerId}`
  );

  const createSftpConnection = usePostProviderSftpConnection();
  const mutateOptions = useMutateOptions<IProviderSftpConnectionResponse>();

  const onGoToDetail = () =>
    navigate(
      `/settings/provider/${providerId}/sftp-connection/${salesChannelId}/keys`
    );

  const onCreateSale = async (
    values: IProviderSftpConnectionResponse,
    helpers: FormikHelpers<IProviderSftpConnectionResponse>
  ) => {
    await createSftpConnection.mutateAsync(
      { ...values, providerId, salesChannelId },
      {
        ...mutateOptions(helpers),
        onSuccess: () => onGoToDetail(),
      }
    );
  };

  return (
    <Form.SftpConnection
      i18nextPrefix='sftp-connection'
      onSubmit={onCreateSale}
      initialValues={sftpConnectionInitialValue}
      customBackItem={
        <Button
          type='button'
          onlyIcon
          onClick={() => navigate(`/settings/provider/${providerId}`)}>
          <Button.Icon icon={<PiX />} />
        </Button>
      }
      topbarContent={
        <Button type='submit' variant={BUTTON_VARIANT.submit}>
          <Button.Text text={t('button.create')} />
        </Button>
      }
    />
  );
};

export default CreateSftpConnection;
